import * as types from '../actions/types';
import { fetchingCEPFailed, fetchingCEPRequest, fetchingCEPSuccess, onRegisterDirtyField } from './reducers';

const initialState = {
  isFetchingCep: false,
  cepNotFound: undefined,
  dirtyForms: {}
};


export default (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_CEP_FAIL:
      return fetchingCEPFailed(state);
    case types.CEP_REQUEST:
      return fetchingCEPRequest(state);
    case types.CEP_SUCCESS:
      return fetchingCEPSuccess(state);
    case types.CEP_RESET_STATE:
      return initialState;
    case types.REGISTER_DIRTY_FIELD:
      return onRegisterDirtyField(state, action.payload);
    default:
      return state;
  } 
};
